// src/ForgotPasswordForm.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css';
import axios from 'axios';

const ForgotPassword = () => {
  const [id, setId] = useState('');
  const [errorText, setErrorText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const API_URL = import.meta.env.VITE_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    if (!id.trim()) {
      setErrorText('メールアドレス（ユーザーID）を入力してください。');
      return;
    }
  
    try {
      setSubmitting(true);
      setErrorText('');

      const res = await axios.post(
            `${API_URL}/api/auth/password-reset-requests/`,
            { WAMID: id }
            );

           if (res.data?.success) {
            localStorage.setItem('lastLoginID', id);
            // 成功画面や案内ページに遷移
             navigate('/auth/notice/reset-sent')
            } else {
            setErrorText(res.data?.message || 'リクエストを処理できませんでした。');
            }
    } catch (err) {
      setErrorText('通信エラーが発生しました。時間をおいて再度お試しください。');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card" role="dialog" aria-labelledby="forgot-title">
        <h2 id="forgot-title" className="login-title">パスワード再設定</h2>
        <p className="login-subtitle">
          登録済みのメールアドレスをご入力ください。<br />
          新しいパスワードを設定するためのリンクをお送りします。
        </p>

        {errorText && <div className="error-alert" role="alert">{errorText}</div>}

        <form onSubmit={handleSubmit} noValidate>
          
          <div className="form-group">
            <label htmlFor="fp-id">ユーザーID（メールアドレス）</label>
            <input
              id="fp-id"
              type="email"
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="your@example.com"
              required
              autoComplete="username"
            />
          </div>

          <button type="submit" className="login-button" disabled={submitting}>
            {submitting ? '送信中…' : '送信'}
          </button>
        </form>

         <div style={{ marginTop: 10, textAlign: 'center', fontSize: 13 }}>
           <Link to="/login">ログインに戻る</Link>
         </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
